import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import AcadlyPasswordTextField, { Props as AcadlyPasswordTextFieldProps } from '../FormControls/PasswordTextField';

type VMProps<T extends FieldValues> = UseControllerProps<T>;

const usePasswordTextFieldVM = <T extends FieldValues>({ control, name, defaultValue }: VMProps<T>) => {
  const controller = useController({ control, name, defaultValue });
  return { controller };
};

type Props<T extends FieldValues> = VMProps<T> &
  DistributiveOmit<AcadlyPasswordTextFieldProps, 'ref' | 'inputRef' | 'name' | 'value' | 'onChange' | 'onBlur'>;

const PasswordTextField = <T extends FieldValues>({ control, name, defaultValue, helperText, ...props }: Props<T>) => {
  const { controller } = usePasswordTextFieldVM({ control, name, defaultValue });
  const { field, fieldState } = controller;
  const { ref: inputRef, value, onChange, onBlur } = field;
  const { error } = fieldState;

  return (
    <AcadlyPasswordTextField
      {...props}
      inputRef={inputRef}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={Boolean(error)}
      aria-invalid={Boolean(error)}
      helperText={error?.message ?? helperText}
    />
  );
};

export default PasswordTextField;
